import axios from "axios"
import parseObjectToUrlParams from "./utils/parseObjectToUrlParams";

const configMethodPath = {};

export default {
  carTypes: {
    create: (data) => axios.post(`/api-v2/car-types`, data),
    list: (queryParams = {}) => axios.get('/api-v2/car-types?' + parseObjectToUrlParams({
      page: 1,
      itemsPerPage: 5000,
      ...queryParams,
    })),
  },
  carMakes: {
    list: (queryParams = {}) => axios.get('/api-v2/car-makes?' + parseObjectToUrlParams({
      page: 1,
      itemsPerPage: 5000,
      ...queryParams,
    })),
  },
  carModels: {
    list: (queryParams = {}) => axios.get('/api-v2/car-models?' + parseObjectToUrlParams({
      page: 1,
      itemsPerPage: 5000,
      ...queryParams,
    })),
  },
  clients: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/clients?' + queryParams),
    delete: id => axios.delete(`/api-v2/clients/${id}`),
  },
  clientPayments: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/client-payments?' + queryParams),
  },
  cardControlInUse: {
    update: (data) => axios.patch(`/api-v2/card-control-in-uses/${data.id}`, data, configMethodPath),
    option: {
      update: (data) => axios.patch(`/api-v2/card-control-in-uses/options/${data.id}`, data, configMethodPath),
    },
  },
  jobTemplates: {
    get: id => axios.get(`/api-v2/job-templates/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        products: res.data.products['hydra:member'],
      }
    })),
    create: data => axios.post('/api-v2/job-templates', data),
    createFromJobCategoryGlobals: data => axios.post('/api-v2/job-templates/create-from-job-category-globals', data),
    delete: id => axios.delete(`/api-v2/job-templates/${id}`),
    update: (data) => axios.patch(`/api-v2/job-templates/${data.id}`, data, configMethodPath),
    list: (queryParams = 'page=1') => axios.get(`/api-v2/job-templates?${queryParams}`),
    patch: (id, data) => axios.patch(`/api-v2/job-templates/${id}`, data, configMethodPath),
    post: data => axios.post('/api-v2/job-templates', data),
    postFromRepairOrderJob: data => axios.post('/api-v2/job-templates/from-repair-order-job', data),
  },
  jobCategory: {
    create: (data) => axios.post('/api-v2/job-categories', data),
    delete: (id) => axios.delete(`/api-v2/job-categories/${id}`),
    list: () => axios.get('/api-v2/job-categories'),
  },
  jobCategoryGlobal: {
    list: () => axios.get('/api-v2/job-category-globals'),
  },
  repairOrders: {
    // getDateAdmissionNotifyContentPrepared: id => axios.get(`/api-v2/repair-orders/${id}/date-admission-notify-content-prepared`),
    fromQuotation: (quotationId, repairOrderId = null) => axios.post(`/api-v2/repair-order/from-quotation`, {quotationId, repairOrderId}),
    getDateAdmissionNotifyContentPrepared: repairOrder => axios.post('/api-v2/repair-order/date-admission-notify-content-prepared', { repairOrder }),
    getCostEstimateSms: id => axios.get(`/api-v2/repair-orders/${id}/cost-estimate-sms`),
    create: data => axios.post(`/api-v2/repair-orders`, data),
    createCustom: data => axios.post(`/api-v2/repair-orders/custom`, data),
    createFromStorageDocument: storageDocumentId => axios.post(`/api-v2/repair-orders/from-storage-document`, {storageDocumentId}),
    updatePartial: (data) => axios.patch(`/api-v2/repair-orders/${data.id}/partial`, data, configMethodPath),
    updateTecRmiData: (id, typeDetails) => axios.patch(`/api-v2/repair-orders/${id}/tec-rmi`, typeDetails, configMethodPath),
    delete: id => axios.delete(`/api-v2/repair-orders/${id}`),
    list: (queryParams = 'page=1') => axios.get(`/api-v2/repair-orders?${queryParams}`),
    createJobs: (id, data) => axios.put(`/api-v2/repair-orders/${id}/jobs`, data),
    getDetails: (id) => axios.get(`/api-v2/repair-orders/${id}/details`),
    getForWorker: (id) => axios.get(`/api-v2/repair-orders/${id}/for-worker`),
    updateAdvancePaymentAmount: (data) => axios.patch(`/api-v2/repair-orders/${data.id}/update-advance`, data, configMethodPath),

    jobs: {
      get: jobId => axios.get(`/api-v2/repair-orders/jobs/${jobId}`),
      updatePartial: (data) => axios.patch(`/api-v2/repair-orders/jobs/${data.id}/partial`, data, configMethodPath),
      list: (queryParams = 'page=1') => axios.get(`/api-v2/jobs?${queryParams}`),
      postFromJobTemplate: (data) => axios.post(`/api-v2/repair-orders/jobs/from-job-template`, data),
      createTecRmiServiceProposalWork: (data) => axios.post(`/api-v2/repair-orders/jobs/tec-rmi-service-proposal-work`, data),
      updateJobTemplate: (jobId, data) => axios.patch(`/api-v2/repair-orders/jobs/${jobId}/change-job-template`, data, configMethodPath),
      updateWorkers: (jobId, data) => axios.patch(`/api-v2/repair-orders/jobs/${jobId}/update-workers`, data, configMethodPath),
      updateJobWorkersCommitmentPercentages: (jobId, data) => axios.patch(`/api-v2/repair-orders/jobs/${jobId}/job-workers-commitment-percentages`, data, configMethodPath),
      updateDiscountBulk: (data) => axios.post('/api-v2/repair-orders/jobs/update-discount/bulk', data),
      inWorkTimes: {
        list: (queryParams = 'page=1') => axios.get(`/api-v2/repair-order-jobs/in-work-times?${queryParams}`),
      }
    },
    parts: {
      updateDiscountBulk: (data) => axios.post('/api-v2/repair-orders/parts/update-discount/bulk', data),
    },

    damages: {
      create: (data) => axios.post(`/api-v2/repair-order/damages`, data),
      update: (data) => axios.patch(`/api-v2/repair-order/damages/${data.id}`, data, configMethodPath),
      delete: id => axios.delete(`/api-v2/repair-order/damages/${id}`),
      list: (repairOrderId, queryParams = 'page=1') => axios.get(`/api-v2/repair-order/damages?repairOrder=${repairOrderId}&${queryParams}`),
    },
    files: {
      patch: (data) => axios.patch(`/api-v2/repair-orders/files/${data.id}`, data, configMethodPath),
    }
  },
  repairOrderKinds: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/repair-order-kinds?' + queryParams),
  },
  notifications: {
    delete: id => axios.delete(`/api-v2/notifications/${id}`),
    getMore: (from_id) => axios.get(`/api-v2/notifications/get-more?from_id=${from_id}`),
    unreadCount: () => axios.get(`/api-v2/notifications/unread-count`),
    setAsRead: (id) => axios.get(`/api-v2/notifications/${id}/set-as-read`),
    setAsUnread: (id) => axios.get(`/api-v2/notifications/${id}/set-as-unread`),
    markAllAsRead: () => axios.get(`/api-v2/notifications/mark-all-as-read`),
    sendSystemChangelogUpdated: () => axios.post('/api-v2/notifications/send-system-changelog-updated'),
  },
  quotations: {
    prepareSms: id => axios.get(`/api-v2/quotations/${id}/prepare-sms`),
    create: data => axios.post('/api-v2/quotations', data),
    delete: id => axios.delete(`/api-v2/quotations/${id}`),
    update: (data) => axios.patch(`/api-v2/quotations/${data.id}`, data, configMethodPath),
    get: id => axios.get(`/api-v2/quotations/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        jobs: res.data.jobs['hydra:member'],
        parts: res.data.parts['hydra:member'],
      }
    })),
  },
  products: {
    delete: id => axios.delete(`/api-v2/products/${id}`),
  },
  tireMakes: {
    list: (queryParams = {}) => axios.get('/api-v2/tire-makes?' + parseObjectToUrlParams({
      page: 1,
      itemsPerPage: 5000,
      ...queryParams,
    })),
  },
  rimMakes: {
    list: (queryParams = {}) => axios.get('/api-v2/rim-makes?' + parseObjectToUrlParams({
      page: 1,
      itemsPerPage: 5000,
      ...queryParams,
    })),
  },
  warehouseProducts: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/warehouse-product-list?' + queryParams),
    findByCodeEan: code => axios.get('/api-v2/warehouse-products/find-by-code-ean?code=' + code),
  },
  clientMail: {
    create: data => axios.post('/api-v2/client-mails', data),
    delete: id => axios.delete(`/api-v2/client-mails/${id}`),
    updatePartial: (data) => axios.patch(`/api-v2/client-mails/${data.id}/partial`, data, configMethodPath),
  },
  smsMessages: {
    create: data => axios.post('/api-v2/sms-messages', data),
    list: (queryParams = 'page=1') => axios.get('/api-v2/sms-messages?' + queryParams),
    delete: id => axios.delete(`/api-v2/sms-messages/${id}`),
    updatePartial: (data) => axios.patch(`/api-v2/sms-messages/${data.id}/partial`, data, configMethodPath),
  },
  cashBoxes: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/cash-boxes?' + queryParams),
    create: data => axios.post('/api-v2/cash-boxes', data),
    get: id => axios.get(`/api-v2/cash-boxes/${id}`),
    getCurrentValue: (id = 0) => axios.get(`/api-v2/cash-boxes/${id}/current-value`),
    update: (data) => axios.patch(`/api-v2/cash-boxes/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/cash-boxes/${id}`),
  },
  cashBoxDocuments: {
    create: data => axios.post('/api-v2/cash-box-documents', data),
    get: id => axios.get(`/api-v2/cash-box-documents/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
      }
    })),
    update: (data) => axios.patch(`/api-v2/cash-box-documents/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/cash-box-documents/${id}`),
  },
  storageDocuments: {
    create: data => axios.post('/api-v2/storage-documents', data),
    get: id => axios.get(`/api-v2/storage-documents/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        tasks: res.data.tasks['hydra:member'],
      }
    })),
    update: (data) => axios.patch(`/api-v2/storage-documents/${data.id}`, data, configMethodPath),
    updatePartial: (data) => axios.patch(`/api-v2/storage-documents/${data.id}/partial`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/storage-documents/${id}`),
    tasks: {
      updatePartial: (data) => axios.patch(`/api-v2/storage-document/tasks/${data.id}/partial`, data, configMethodPath),
    }
  },
  proFormaDocuments: {
    create: data => axios.post('/api-v2/pro-forma-documents', data),
    update: (data) => axios.patch(`/api-v2/pro-forma-documents/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/pro-forma-documents/${id}`),
    get: id => axios.get(`/api-v2/pro-forma-documents/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        saleDocumentAdvanceInvoices: res.data.saleDocumentAdvanceInvoices['hydra:member'],
        payments: res.data.payments['hydra:member'],
      }
    })),
    payments: {
      create: (data) => axios.post(`/api-v2/pro-forma-documents/${data.document}/payments`, data),
      delete: id => axios.delete(`/api-v2/pro-forma-document/payments/${id}`),
      list: (queryParams = 'page=1') => axios.get('/api-v2/pro-forma-document/payments?' + queryParams),
      updatePartial: (data) => axios.patch(`/api-v2/pro-forma-document/payments/${data.id}/partial`, data, configMethodPath),
    },
    prepareFromRepairOrders: (type, repairOrderIds) => axios.get(`/api-v2/pro-forma-document/prepare-from-repair-orders?ids=${repairOrderIds}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
      }
    })),
  },
  saleDocuments: {
    create: data => axios.post('/api-v2/sale-documents', data),
    get: id => axios.get(`/api-v2/sale-documents/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
        saleDocumentSource: res.data.saleDocumentSource ? {
          ...res.data.saleDocumentSource,
          items: res.data.saleDocumentSource.items['hydra:member'],
        } : null,
        saleDocumentSourceLatestWithItems: res.data.saleDocumentSourceLatestWithItems ? {
          ...res.data.saleDocumentSourceLatestWithItems,
          items: res.data.saleDocumentSourceLatestWithItems.items['hydra:member'],
          saleDocumentReceiptFiscal: res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal ? {
            ...res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal,
            items: res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal.items['hydra:member'],
          } : null
        } : null,
      }
    })),
    bsxPrinter: {
      cancelPrinting: id => axios.get(`/api-v2/sale-documents/${id}/bsx-printer/cancel-printing`),
    },
    list: (queryParams = 'page=1') => axios.get('/api-v2/sale-document-list?' + queryParams),
    update: (data) => axios.patch(`/api-v2/sale-documents/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/sale-documents/${id}`),
    receiptFiscalPrint: id => axios.get(`/api-v2/sale-documents/${id}/receipt-fiscal-print`),
    prepareFromSaleDocumentCorrection: (type, saleDocumentToCorrection, correctionType) => axios.get(`/api-v2/sale-documents/prepare-sale-document-correction?type=${type}&id=${saleDocumentToCorrection}&correctionType=${correctionType}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        saleDocumentSource: {
          ...res.data.saleDocumentSource,
          items: res.data.saleDocumentSource.items['hydra:member'],
        },
        saleDocumentSourceLatestWithItems: res.data.saleDocumentSourceLatestWithItems ? {
          ...res.data.saleDocumentSource,
          items: res.data.saleDocumentSourceLatestWithItems.items['hydra:member'],
          saleDocumentReceiptFiscal: res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal ? {
            ...res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal,
            items: res.data.saleDocumentSourceLatestWithItems.saleDocumentReceiptFiscal.items['hydra:member'],
          } : null
        } : null,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
      }
    })),
    prepareFromSaleDocumentReceiptFiscal: (type, saleDocumentReceiptFiscal) => axios.get(`/api-v2/sale-documents/prepare-from-sale-document-receipt-fiscal?type=${type}&id=${saleDocumentReceiptFiscal}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
      }
    })),
    prepareFromProFormaDocument: (type, proFormaDocument) => axios.get(`/api-v2/sale-documents/prepare-from-pro-forma-document?type=${type}&id=${proFormaDocument}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
      }
    })),
    prepareFromRepairOrders: (type, repairOrderIds) => axios.get(`/api-v2/sale-documents/prepare-from-repair-orders?type=${type}&ids=${repairOrderIds}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
      }
    })),
    prepareFromStorageDocuments: (type, storageDocumentsIds) => axios.get(`/api-v2/sale-documents/prepare-from-storage-documents?type=${type}&ids=${storageDocumentsIds}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        payments: res.data.payments['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
        storageDocuments: res.data.storageDocuments['hydra:member'],
      }
    })),
    payments: {
      create: (data) => axios.post(`/api-v2/sale-documents/${data.document}/payments`, data),
      delete: id => axios.delete(`/api-v2/sale-document/payments/${id}`),
      list: (queryParams = 'page=1') => axios.get('/api-v2/sale-document/payments?' + queryParams),
      updatePartial: (data) => axios.patch(`/api-v2/sale-document/payments/${data.id}/partial`, data, configMethodPath),
    },
  },
  warehouseDocuments: {
    create: data => axios.post('/api-v2/warehouse-documents', data),
    get: id => axios.get(`/api-v2/warehouse-documents/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        repairOrders: res.data?.repairOrders ? res.data?.repairOrders['hydra:member'] : [],
      }
    })),
    list: (queryParams = 'page=1') => axios.get('/api-v2/warehouse-document-list?' + queryParams),
    update: (data) => axios.patch(`/api-v2/warehouse-documents/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/warehouse-documents/${id}`),
    prepareRwFromRepairOrders: (repairOrderIds) => axios.get(`/api-v2/warehouse-documents/prepare-rw-from-repair-orders?ids=${repairOrderIds}`, {}).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
        repairOrders: res.data.repairOrders['hydra:member'],
      }
    })),
    item: {
      list: (queryParams) => axios.get('/api-v2/warehouse-document-item-list?' + queryParams)
    }
  },
  warehouseDocumentsInventory: {
    create: data => axios.post('/api-v2/warehouse-document-inventories', data),
    get: id => axios.get(`/api-v2/warehouse-document-inventories/${id}`).then(res => ({
      ...res,
      data: {
        ...res.data,
        items: res.data.items['hydra:member'],
      }
    })),
    end: (id) => axios.get(`/api-v2/warehouse-document-inventories/${id}/end`),
    list: (queryParams = 'page=1') => axios.get('/api-v2/warehouse-document-inventories?' + queryParams),
    update: (data) => axios.patch(`/api-v2/warehouse-document-inventories/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/warehouse-document-inventories/${id}`),
  },
  reminders: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/reminders?' + queryParams),
  },
  workshop: {
    getByUserId: userId => axios.get(`/api-v2/workshops/get-by-user?user=${userId}`),
    get: id => axios.get(`/api-v2/workshops/${id}`),
    delete: id => axios.delete(`/api-v2/workshops/${id}`),
    update: (data) => axios.patch(`/api-v2/workshops/${data.id}`, data, configMethodPath),
    updateReminder: (data) => axios.patch(`/api-v2/workshops/${data.id}/reminders`, data, configMethodPath),
    updateMailIntegration: (data) => axios.patch(`/api-v2/workshops/${data.id}/mail-integration`, data, configMethodPath),
    updateBrowserPluginConfiguration: (data) => axios.patch(`/api-v2/workshops/${data.id}/browser-plugin-configuration`, data, configMethodPath),
    integration: {
      update: (data) => axios.patch(`/api-v2/workshop/integrations/${data.id}`, data, configMethodPath),
      tpayRegistrationInitial: (data) => axios.post(`/api-v2/workshops/integration/tpay-registration/initial`, data),
      tpayRegistration: {
        step: (data, stepNumber) => axios.post(`/api-v2/workshops/integration/tpay-registration/step${stepNumber}`, data),
        finish: (data) => axios.post(`/api-v2/workshops/integration/tpay-registration/finish`, data),
      },
      tpayConfiguration: data => axios.post(`/api-v2/workshop/integrations/tpay-configuration`, data),
    },
    getDefaultDocumentText: documentKey => axios.get(`/api-v2/workshop-settings/default-document-text/${documentKey}`),
  },

  userResetPasswords: {
    create: data => axios.post('/api-v2/user-reset-passwords', data),
    get: id => axios.get(`/api-v2/user-reset-passwords/${id}`),
    changePassword: (id, data) => axios.post(`/api-v2/user-reset-passwords/change-password`, { id, data }),
  },

  users: {
    get: id => axios.get(`/api-v2/users/${id}`),
    workshop: userId => axios.get(`/api-v2/users/${userId}/workshop`),
    getToken: (id) => axios.get(`/api-v2/users/${id}/token`),
    list: (queryParams = 'page=1') => axios.get('/api-v2/users?' + queryParams),
    updatePartial: (data) => axios.patch(`/api-v2/users/${data.id}/partial`, data, configMethodPath),
    updateSurveyResponse: () => axios.patch(`/api-v2/user/survey-response`, [], configMethodPath),
    updateScreenBackground: (data) => axios.patch(`/api-v2/user/screen-background`, data, configMethodPath),
    checkPassword: (data) => axios.post(`/api-v2/user/check-password`, data, configMethodPath),
  },
  worker: {
    updateScreenBackground: (data) => axios.patch(`/api-v2/worker/screen-background`, data, configMethodPath),
    checkPassword: (data) => axios.post(`/api-v2/worker/check-password`, data, configMethodPath),
  },
  workshopPlans: {
    acceptDiscount: (code) => axios.post(`/api-v2/workshop-plan/accept-discount`, { code }),
    payUCancelCreditCard: () => axios.post(`/api-v2/workshop-plan/payu-cancel-credit-card`, { }),
    getSmsAvailableCount: () => axios.get('/api-v2/workshop-plan/sms-available-count'),
    update: (data) => axios.patch(`/api-v2/workshop-plans/${data.id}`, data, configMethodPath),
    updateDemo: (data) => axios.patch(`/api-v2/workshop-plan/update-demo`, data, configMethodPath),
    planSettings: {
      betis: {
        activate: () => axios.post('/api-v2/workshop-plan/plan-settings/betis/activate', {}),
        modalDisplayed: () => axios.post('/api-v2/workshop-plan/plan-settings/betis/modal-displayed', {}),
        updateContact: (data) => axios.patch('/api-v2/workshop-plan/plan-settings/betis/contact', data, configMethodPath),
      },
    },
  },

  workshopPlanTransaction: {
    checkLast: () => axios.get(`/api-v2/workshop-plan-transactions/check-last`),
    changePlan: (data) => axios.post(`/api-v2/workshop-plan-transactions/change-plan`, data),
    extendPlan: (data) => axios.post(`/api-v2/workshop-plan-transactions/extend-plan`, data),
    smsPackage: (data) => axios.post(`/api-v2/workshop-plan-transactions/sms-package`, data),
    vehicleByRegNumber: (data) => axios.post(`/api-v2/workshop-plan-transactions/vehicle-by-reg-number-package`, data),
    tecRmiAccess: (data) => axios.post(`/api-v2/workshop-plan-transactions/tec-rmi-access`, data),
  },

  jpk: {
    jpkFa: (date) => `/api/jpk/fa?data=${date}`,
    jpkVat7: (date) => `/api/jpk/vat7?data=${date}`,
    jpkMag: (date) => `/api/jpk/mag?data=${date}`,
    createJpkExport: (data) => axios.post('/api-v2/jpk-exports', data),
  },

  vat: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/vats?' + queryParams),
  },
  vehicles: {
    delete: id => axios.delete(`/api-v2/vehicles/${id}`),
    list: (queryParams = 'page=1') => axios.get('/api-v2/vehicles?' + queryParams),
    update: (data) => axios.patch(`/api-v2/vehicles/${data.id}`, data, configMethodPath),
    mergeVehicles: (data) => axios.post(`/api-v2/vehicles/${data.id}/merge-vehicles`, data),
    checkVin: (data) => axios.get(`/api-v2/vehicles/check-vin/${data.vin}`, data),
    fetchByRegistrationNumber: (registrationNumber) => axios.get(`/api-v2/vehicles/fetch-by-registration-number/${registrationNumber}`),
    fetchByVin: (vin) => axios.get(`/api-v2/vehicles/fetch-by-vin/${vin}`),
    getMileageCollection: (data) => axios.get(`/api-v2/vehicles/${data.id}/mileages`, data),
    mileages: {
      update: (data) => axios.patch(`/api-v2/vehicles/${data.vehicleId}/mileages-update`, data, configMethodPath),
      delete: (data) => axios.patch(`/api-v2/vehicles/${data.vehicleId}/mileages-delete`, data, configMethodPath),
    },
    vehicleMileages: {
      create: (data) => axios.post(`/api-v2/vehicles/${data.vehicleId}/mileages`, data),
    }
  },
  licenseActivationCode: {
    activate: licenseCode => axios.get(`/api-v2/license-activation-codes/${licenseCode}/activate`)
  },

  bsxPrinterAuths: {
    list: (queryParams = 'page=1') => axios.get('/api-v2/bsx-printer-auths?' + queryParams),
    create: data => axios.post('/api-v2/bsx-printer-auths', data),
    update: data => axios.patch(`/api-v2/bsx-printer-auths/${data.id}`, data, configMethodPath),
    delete: id => axios.delete(`/api-v2/bsx-printer-auths/${id}`),
  },

  storageDocumentTaskTemplates: {
    create: data => axios.post('/api-v2/storage-document-task-templates', data),
    delete: id => axios.delete(`/api-v2/storage-document-task-templates/${id}`),
    list: (queryParams = 'page=1') => axios.get(`/api-v2/storage-document-task-templates?${queryParams}`),
    patch: (data) => axios.patch(`/api-v2/storage-document-task-templates/${data.id}`, data, configMethodPath),
  },

  _view: {
    repairOrderList: (queryParams = 'page=1') => axios.get('/api-v2/repair-order-lists?' + queryParams),
    quotationList: (queryParams = 'page=1') => axios.get('/api-v2/quotation-lists?' + queryParams),
    clientMailList: (queryParams = 'page=1') => axios.get('/api-v2/client-mail-lists?' + queryParams),
    cashBoxDocumentList: (queryParams = 'page=1') => axios.get('/api-v2/cash-box-document-lists?' + queryParams),
    storageDocumentList: (queryParams = 'page=1') => axios.get('/api-v2/storage-document-lists?' + queryParams),
    proFormaDocumentList: (queryParams = 'page=1') => axios.get('/api-v2/pro-forma-document-lists?' + queryParams),
    warehouseDocumentInventoryList: (queryParams = 'page=1') => axios.get('/api-v2/warehouse-document-inventory-lists?' + queryParams),
    warehouseProducts: {
      get: (id) => axios.get('/api-v2/warehouse-product-lists/'+id),
      list: (queryParams = 'page=1') => axios.get('/api-v2/warehouse-product-lists?' + queryParams),
    },
    workshopList: (queryParams = 'page=1') => axios.get('/api-v2/workshop-lists?' + queryParams),
    workshopPlanTransactionList: (queryParams = 'page=1') => axios.get('/api-v2/workshop-plan-transaction-lists?' + queryParams),
  },
};